import { render, staticRenderFns } from "./SpecialColumnNewsList.vue?vue&type=template&id=5ed0790a&"
import script from "./SpecialColumnNewsList.vue?vue&type=script&lang=js&"
export * from "./SpecialColumnNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports